module.exports = __webpack_public_path__ + "static/media/hengshan_mobile.1f918435.png";